import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  StyledBox,
  StyledBoxCard,
} from "./style";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Form, Formik } from "formik";
import theme from "../../../theme";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { StyledBoxFlex } from "../success-virtual-locker/style";
import { StyledTypography } from "../manual-split-calculation/style";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import CustomInput from "../../common/input/CustomInput";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import { CouponStatusOptionDropdown } from "../product-details/constant";
import { SETTING_COUPON_ADD, SETTING_COUPON_EDIT, SETTING_COUPON_LIST } from "../../../actions/admin/customer-actions";

// Yup Validation Schema
const validationSchema = Yup.object({

  code: Yup.string()
    .trim()
    .required("code is required")
    .min(2, "code must be at least 2 characters")
    .max(50, "code must be at most 50 characters"),

  valid_until: Yup.string()
    .required("Valid to is required"),

  valid_from: Yup.string()
    .required("Valid from is required"),

  discount_type: Yup.string()
    .required("Discount type is required"),
  
  discount_value: Yup.string()
    .required("Discount value is required"),

  max_amount: Yup.string()
    .required("Maximum amount is required"),

  status: Yup.string()
    .required("Status is required"),

});

export default function SettingCoupon({ open, handleClose, isEditMode, editRecord }) {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = React.useState({
    code: "",
    valid_until: "",
    valid_from: "",
    discount_type: "",
    discount_value: "",
    max_amount: "",
    status: "",
  })
  
  const getRecordList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_COUPON_LIST,
        payload: values,
      });
    },
    [dispatch]
  );

  React.useEffect(()=>{
    if(isEditMode){
      setInitialValue({
        code: editRecord?.code || "",
        valid_until: editRecord?.valid_until || "",
        valid_from: editRecord?.valid_from || "",
        discount_type: editRecord?.discount_type || "",
        discount_value: editRecord?.discount_value || "",
        max_amount: editRecord?.max_amount || "",
        status: editRecord?.status || "",
      })
    }
  }, [isEditMode, editRecord])

  const formatDate = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0];
};
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <StyledTypography>Create Coupon</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            if(isEditMode && editRecord.id){
              dispatch({
                type: SETTING_COUPON_EDIT,
                payload: {
                  ...values,
                  id: editRecord.id,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            } else {
              dispatch({
                type: SETTING_COUPON_ADD,
                payload: {
                  ...values,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, handleChange, handleBlur }) => (
            <Form>
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  {/* code */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Code"
                      customLabel="Code"
                      name={`code`}
                      value={values.code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.code &&
                        Boolean(errors.code)
                      }
                      helperText={
                        touched.code &&
                        errors.code
                      }
                    />
                  </Grid>

                  {/* valid_from */}
                  {/* {console.log("checkdata",values?.valid_from)} */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                      <CustomInput
                        color={
                          theme.palette.custom.productTextColor
                        }
                        fontSize={theme.typography.regular.fontSize}
                        height="10px"
                        required
                        value={formatDate(values.valid_from)}
                        type="date"
                        placeholder="Valid From"
                        customLabel="Valid From"
                        name={`valid_from`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.valid_from &&
                          Boolean(errors.valid_from)
                        }
                        helperText={
                          touched.valid_from &&
                          errors.valid_from
                        }
                      />
                    {/* <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Valid From"
                      customLabel="Valid From"
                      name={`valid_from`}
                      value={values.valid_from}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.valid_from &&
                        Boolean(errors.valid_from)
                      }
                      helperText={
                        touched.valid_from &&
                        errors.valid_from
                      }
                    /> */}
                  </Grid>

                  {/* valid_until */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                        color={
                          theme.palette.custom.productTextColor
                        }
                        fontSize={theme.typography.regular.fontSize}
                        height="10px"
                        required
                        type="date"
                        placeholder="Valid To"
                        customLabel="Valid To"
                        value={formatDate(values.valid_until)}
                        name={`valid_until`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.valid_until &&
                          Boolean(errors.valid_until)
                        }
                        helperText={
                          touched.valid_until &&
                          errors.valid_until
                        }
                      />
                    {/* <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Valid To"
                      customLabel="Valid To"
                      name={`valid_until`}
                      value={values.valid_until}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.valid_until &&
                        Boolean(errors.valid_until)
                      }
                      helperText={
                        touched.valid_until &&
                        errors.valid_until
                      }
                    /> */}
                  </Grid>

                  {/* Discount Type */}
                   <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={[
                        { label: "Percetage", value: "percentage" },
                        { label: "Fixed", value: "fixed" },
                      ]}
                      color={theme.palette.custom.productTextColor}
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      required
                      customLabel="Discount Type"
                      name="discount_type"
                      value={values?.discount_type}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={touched.discount_type && Boolean(errors.discount_type)}
                      helperText={touched.discount_type && errors.discount_type}
                    />
                  </Grid>

                  {/* Discount Value */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Discount Value"
                      customLabel="Discount Value"
                      name={`discount_value`}
                      value={values.discount_value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.discount_value &&
                        Boolean(errors.discount_value)
                      }
                      helperText={
                        touched.discount_value &&
                        errors.discount_value
                      }
                    />
                  </Grid>

                  {/* Maximum Value */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Maximum Value"
                      customLabel="Maximum Value"
                      name={`max_amount`}
                      value={values.max_amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.max_amount &&
                        Boolean(errors.max_amount)
                      }
                      helperText={
                        touched.max_amount &&
                        errors.max_amount
                      }
                    />
                  </Grid>

                  {/* Status */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={CouponStatusOptionDropdown}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      required
                      customLabel="Status"
                      name={`status`}
                      value={values.status}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={
                        touched.status &&
                        Boolean(errors.status)
                      }
                      helperText={
                        touched.status &&
                        errors.status
                      }
                    />
                  </Grid>

                      {/* Submit */}
                  <Grid container justifyContent="space-between" width="100%">
                    <Grid item>
                      <Button variant="outlined" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button variant="contained" color="primary" type="submit">
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
